import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

const { Text, Title } = Typography

export function AccountDeletionRequestsHeader() {
  const { t } = useTranslation()

  return (
    <Flex justify={"space-between"} wrap gap={"small"} align={"center"}>
      <Flex vertical>
        <Title className={"text-start"} level={2}>
          {t("accountDeletionRequests.title")}
        </Title>
        <Text type={"secondary"}>{t("accountDeletionRequests.subtitle")}</Text>
      </Flex>
      <Text type={"secondary"}>{t("accountDeletionRequests.note")}</Text>
    </Flex>
  )
}
